import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as myGlobals from '../app.component';

@Injectable({
  providedIn: 'root'
})
export class FacultyService {

  private baseUrl = myGlobals.baseUrl;

  constructor(private http: HttpClient) { }

  submitFacultyDetails(data) {
    return this.http.post(`${this.baseUrl}/submitFacultyDetails`, data);
  }

  getFacultyDetails() {
    return this.http.get(`${this.baseUrl}/getFacultyDetails`);
  }

  submitFacultyAttachment(data) {
    return this.http.post(`${this.baseUrl}/submitFacultyAttachment`, data);
  }

  getFacultyAttachment() {
    return this.http.get(`${this.baseUrl}/getFacultyAttachment`);
  }

  submitFacultyWorkingStatus(data) {
    return this.http.post(`${this.baseUrl}/submitFacultyWorkigStatus`, data);
  }

  getFacultyWorkingStatus() {
    return this.http.get(`${this.baseUrl}/getFacultyWorkingStatus`);
  }

  getState(token) {
    return this.http.get(`${this.baseUrl}/getState?token=` + token);
  }

  getDistrict(token, data) {
    return this.http.get(`${this.baseUrl}/getDistrict?token=${token}&state_id=` + data);
  }

  submitFacultyProfessionExperience(data) {
    return this.http.post(`${this.baseUrl}/submitFacultyProfessionExperience`, data);
  }

  getFacultyProfessionExperience() {
    return this.http.get(`${this.baseUrl}/getFacultyProfessionExperience`);
  }

  submitFacultyResearchExperience(data) {
    return this.http.post(`${this.baseUrl}/submitFacultyResearchExperience`, data);
  }

  getFacultyResearchExperience() {
    return this.http.get(`${this.baseUrl}/getFacultyResearchExperience`);
  }

  getFacultyRegDetails(data) {
    return this.http.get(`${this.baseUrl}/getFacultyRegDetails?email=` + data);
  }

  deleteFacultyProfessionDetails(data) {
    return this.http.get(`${this.baseUrl}/deleteFacultyProfessionalDetails?id=` + data);
  }

  deleteFacultyResearchDetails(data) {
    return this.http.get(`${this.baseUrl}/deleteFacultyResearchDetails?id=` + data);
  }

  submitedFacultyDetailsFinal() {
    return this.http.get(`${this.baseUrl}/submitedFacultyDetailsFinal`);
  }

  checkFacultyDetailsSubmitted() {
    return this.http.get(`${this.baseUrl}/checkFacultyDetailsSubmitted`);
  }

  getStudents() {
    return this.http.get(`${this.baseUrl}/getFacultyStudents`);
  }

  facultyApplicationPrint(id) {
    return this.http.post(`${this.baseUrl}/facultyApplicationPrint`, id);
  }

  getHodDesignations() {
    return this.http.get(`${this.baseUrl}/getHodDesignations`);
  }

  getAppointmentType() {
    return this.http.get(`${this.baseUrl}/getAppointmentType`);
  }

  getFacultyDepartment() {
    return this.http.get(`${this.baseUrl}/getFacultyDepartment`);
  }

  getTopicsbyDepartment(department_id) {
    return this.http.get(`${this.baseUrl}/getTopicsbyDepartment?department_id=` + department_id);
  }

  getFacultyStudents() {
    return this.http.get(`${this.baseUrl}/getFacultyStudents`);
  }

  getAllFacultyMessages(data) {
    return this.http.get(`${this.baseUrl}/getAllFacultyMessages?role_id=` + data);
  }

  getStudentByYear(data, gap) {
    return this.http.get(`${this.baseUrl}/getStudentByYear?current_year=${data}&gap=${gap}`);
  }

  getFacultySpecializationsDropdDown() {
    return this.http.get(`${this.baseUrl}/getFacultySpecializationsDropdDown`)
  }

  submitFacultySpecializations(data) {
    return this.http.post(`${this.baseUrl}/submitFacultySpecializations`, data);
  }

  getFacultySpecializations(){
    return this.http.get(`${this.baseUrl}/getFacultySpecializations`)
  }

  getFacultyLanguage(){
    return this.http.get(`${this.baseUrl}/getFacultyLanguage`)
  }

  checkFacultyDepartment(){
    return this.http.get(`${this.baseUrl}/checkFacultyDepartment`);
  }

  getDowntime(){
    return this.http.get(`${this.baseUrl}/getDowntime`);
  }
}
